module.exports = __webpack_public_path__ + "static/img/mzd_bluetooth_1.11409c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-bluetooth/mzd_bluetooth_1.png
// module id = jOoF
// module chunks = 215